<p-dialog header="Witness Login" [(visible)]="showDialog" [modal]="true" [style]="{width: '25vw'}" [baseZIndex]="10000"
  [draggable]="false" [resizable]="false">
  <div class="text-left">
    <div class="form-group">
      <label for="exampleInputEmail1">Email</label>
      <input type="text" autocomplete="off" readonly onfocus="if (this.hasAttribute('readonly')) {
                this.removeAttribute('readonly');
                this.blur();    this.focus();  }" [(ngModel)]="username" class="form-control" id="exampleInputEmail1"
        aria-describedby="emailHelp" placeholder="">
    </div>
    <div class="form-group">
      <label for="exampleInputPassword1">Pincode</label>
      <input type="password" autocomplete="off" (keyup)="handleKeyUp($event)" readonly onfocus="if (this.hasAttribute('readonly')) {
                this.removeAttribute('readonly');
                this.blur();    this.focus();  }" [(ngModel)]="password" class="form-control" id="password"
        placeholder="" readonly onfocus="this.removeAttribute('readonly');">
    </div>
    <div *ngIf="isCameraLoginEnabled && (authService.user?.enableCameraLogin||false)"  class="col-8">
      <div>
        <input type="checkbox" name="groupname" (keyup)="handleKeyUp($event)" [(ngModel)]="useCameraLogin">
        <label class="form-check-label ml-2">Witness using camera</label>
      </div>
    </div>
    <div class="ml-2">
      <i class="pi pi-key"></i><span tabindex="0" (click)="showPincodeEdit()" (keydown.enter)="showPincodeEdit()" class="update-pincode-link">Update pincode</span>
    </div>
    <button (click)="authenticateWitness()" class="btn btn-primary float-right mr-2">Login</button>
    <!-- <button (click)="authenticateWitness()" class="btn btn-info float-right mr-2">Update Pin</button>
    <button (click)="authenticateWitness()" class="btn btn-warning float-right mr-2">Cancel</button> -->
  </div>
  <p-dialog header="Error" [(visible)]="haserror" [style]="{width: '30vw'}">
    {{msg}}
  </p-dialog>

</p-dialog>
